import { Environment } from '@abp/ng.core';

const baseUrl = 'https://test.sudocad.com';

const oAuthConfig = {
  issuer: 'https://api-test.sudocad.com/',
  redirectUri: baseUrl,
  clientId: 'Io_App',
  responseType: 'code',
  scope: 'offline_access Io',
  requireHttps: true,
};

export const environment = {
  production: true,
  application: {
    baseUrl,
    name: 'Sudocad - Test',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://api-test.sudocad.com',
      rootNamespace: 'Sudocad.Io',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
} as Environment;